import { useState } from "react";

const PromoCode = () => {
    const [inputVisible, setInputVisible] = useState(false);

    const handleInputVisibility = () => {
        setInputVisible(prevState => !prevState);
    }
    
  return (
    <div>
      <div className="pt-4 flex justify-center flex-col">
        <div onClick={handleInputVisibility} className="title text-[13px] text-gray-600 text-center p-3 transition-all duration-200 hover:bg-gray-100 cursor-pointer">
          <h6 className="font-normal">Have A Promo Code?</h6>
        </div>
        <div className={`overflow-hidden transition-all duration-300 my-2 ${inputVisible? 'max-h-[999px]': 'max-h-0'}`}>
          <input type="text" className={`border-2 border-black w-full rounded-lg p-1 text-center uppercase`} placeholder="Enter Discount Code"/>
        </div>
      </div>
    </div>
  );
};

export default PromoCode;
